/**
 * copied from https://github.com/angular/angular/blob/master/packages/forms/src/validators.ts#L118
 */
export var REGEX_EMAIL = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export var REGEX_USERNAME = /^[a-z][a-z0-9._]*$/i;

/*
 * Matches MX dni
 */
export var REGEX_CURP = /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{0,1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)?[B-DF-HJ-NP-TV-Z]{0,3}[0-9A-Z]{0,1}[0-9]{0,1}$/;

/*
 * Matches Peru dni
 */
export var REGEX_DNI_PERU = /[0-9]{8,9}/;

/**
 * Accepts non numeric characters and spaces (case insensitive)
 */
export var CHARACTERS_ONLY = /^[A-Za-z\s]+$/;

/**
 * Accepts numbers only
 */
export var REGEX_NUMBERS_ONLY = /^[0-9]+$/;

/**
 * Matches $3,023,123.34 | 9,876,453 | 123456.78
 */
export var MONEY = /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(\.[0-9][0-9])?$/;

/**
 * Matches:
 * - dd/mm/yyyy
 * - dd-mm-yyyy
 * - dd.mm.yyyy
 */
export var REGEX_DATE = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{4})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)\d{2})$/;
export var REGEX_URL = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[A-Z]?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/[^()\s,]*)?/g;
export var REGEX_URL_BEGIN = /^(https?:\/\/(www.)?)/;
export var REGEX_FILE = /^[a-z0-9]+([-]{1}[a-z0-9]+)*\.(css|png|jpeg|js|gif|html)$/;
export var REGEX_TAG = /(@(?=.{6,}$))(?![_.])(?!.*[_.]{2})[a-zA-Z0-9_.-]+[^_.<\s]/g;
export var REGEX_TAG_ALONE = /(@(?=.{6,}$))(?![_.])(?!.*[_.]{2})[a-zA-Z0-9_.-]+[^<>_.,;]/g;
export var REGEX_SPAN = /<span class="Global__MentionUsernameColor">[\s\S]+?<\/span>/g;
export var REGEX_A = /<a[\s\S]+?<\/a>/g;
export var REGEX_IMG = /<img(?!.*(src=""))[^>]+?>/g;
export var REGEX_MEDIA = /\[MEDIA .+?\]/g;

// Style regex
export var REGEX_BOLD = /\*\*[\s\S]+?\*\*/g;
export var REGEX_ITALIC = /{{[\s\S]+?}}/g;
export var REGEX_UNDERLINE = /__[\s\S]+?__/g;
export var REGEX_BI = /\\\\[\s\S]+?\\\\/g;
export var REGEX_BU = /--[\s\S]+?--/g;
export var REGEX_IU = /\|\|[\s\S]+?\|\|/g;
export var REGEX_BIU = /\[\[[\s\S]+?\]\]/g;

// Line break regex
export var REGEX_BR = /<br\s*\/?>/g;
export var REGEX_NEWLINE = /\n\r?/g;
export var REGEX_SPACE = /^\s+/g;